import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { trackConversion } from "../../utils/analytics";
import { PricingCard } from "../ui/styles/Marketing";

interface PricingProps {
    onLaunch: () => void;
}

export const Pricing: React.FC<PricingProps> = ({ onLaunch }) => {
    const { t } = useTranslation();

    return (
        <section id="pricing" className="py-24 relative overflow-hidden bg-[#020617]">
            <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-emerald-500/5 blur-[100px] rounded-full pointer-events-none -z-10" />

            <div className="max-w-6xl mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t("landing.pricing.title")}</h2>
                    <p className="text-slate-300">{t("landing.pricing.subtitle")}</p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto items-start">
                    {/* Free Plan */}
                    <div className="hover-lift transition-smooth">
                        <PricingCard
                            title={t("landing.pricing.free.title")}
                            description={t("landing.pricing.free.desc")}
                            price={t("landing.pricing.free.price")}
                            period={t("landing.pricing.free.period")}
                            ctaText={t("landing.pricing.free.cta")}
                            features={t("landing.pricing.free.features") as unknown as string[]}
                            missingFeatures={t("landing.pricing.free.missing") as unknown as string[]}
                            variant="default"
                            onClick={onLaunch}
                        />
                    </div>

                    {/* PRO Plan */}
                    <div className="hover-lift hover-glow transition-smooth rounded-2xl">
                        <PricingCard
                            title={t("landing.pricing.pro.title")}
                            description={t("landing.pricing.pro.desc")}
                            price={t("landing.pricing.pro.price")}
                            originalPrice={t("landing.pricing.pro.originalPrice")}
                            ctaText={t("landing.pricing.pro.cta")}
                            features={t("landing.pricing.pro.features") as unknown as string[]}
                            variant="featured"
                            badge={t("landing.pricing.pro.badge")}
                            footer={
                                <div className="space-y-2">
                                    <p className="text-xs text-brand-300">{t("landing.pricing.pro.priceNote")}</p>
                                    <p className="text-xs text-slate-400">{t("landing.pricing.pro.timer")}</p>
                                </div>
                            }
                            onClick={() => {
                                trackConversion('Upgrade to Pro');
                                // trackGoogleAdsInterest('https://pay.kiwify.com.br/dl571EZ'); // Removed to avoid double redirect
                                // We can manually track the event logic here or just rely on the conversion event
                                window.gtag('event', 'conversion', {
                                    'send_to': 'AW-17795014366/_3RZCNLTxtEbEN69qaVC',
                                });
                                window.open('https://pay.kiwify.com.br/dl571EZ', '_blank');
                            }}
                        />
                        <div className="mt-4 text-center">
                            <button
                                onClick={() => {
                                    localStorage.setItem("PROMPTNINJA_START_TRIAL", "true");
                                    onLaunch();
                                }}
                                className="text-sm font-bold text-brand-400 hover:text-brand-300 transition-colors flex items-center justify-center gap-2 mx-auto py-2 px-4 rounded-lg hover:bg-white/5"
                            >
                                ⚡ {t("host.paywall.trialButton")}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-12 text-sm text-slate-400 whitespace-pre-line">
                    <p>{t("landing.pricing.paymentInfo")}</p>
                </div>
            </div>
        </section>
    );
};
